import { isActiveApplicationStatus } from '@/utils/application-status'

export type CandidateHomeApplication = {
  status: string
  opportunity_id?: string | null
}

export type CandidateHomeSavedJob = {
  id: string
  is_available: boolean
}

export type CandidateHomeMetrics = {
  saved: number
  applications: number
  inReview: number
  shortlisted: number
  interviews: number
}

/**
 * Candidate home KPI row. Saved is every bookmarked job. Shortlisted matches the
 * Jobs Shortlist tab badge: still available and not in an active application.
 */
export function countCandidateHomeMetrics(
  savedJobs: CandidateHomeSavedJob[],
  applications: CandidateHomeApplication[],
  savedTotal = savedJobs.length,
): CandidateHomeMetrics {
  const activeOpportunityIds = new Set<string>()
  let inReview = 0
  let interviews = 0

  for (const app of applications) {
    if (app.status === 'in_review') inReview++
    if (app.status === 'interview') interviews++
    if (app.opportunity_id && isActiveApplicationStatus(app.status)) {
      activeOpportunityIds.add(app.opportunity_id)
    }
  }

  let shortlisted = 0
  for (const job of savedJobs) {
    if (job.is_available && !activeOpportunityIds.has(job.id)) shortlisted++
  }

  return {
    saved: savedTotal,
    applications: applications.length,
    inReview,
    shortlisted,
    interviews,
  }
}
